import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxAsyncPaginatedSelect } from 'components/FormElements/ReduxForm'
import { ErrorText } from 'components/UI/ErrorMessage'
// views
import { Title, UserWrapper } from './views'
import { AddButton, CloseIcon } from 'components/Modals/SystemProcessModal/Form/components/views'
// types
import { IOption } from 'components/FormElements/Select'
import { GroupBase } from 'react-select'
// graphql
import { OWNED_BY_SELECT_QUERY } from 'graphql/plan/queries'
// utils
import { required, Validators } from 'utils/validators'
import { userAndPositionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  addLabel?: string
  itemValidate?: Validators
  prepareOptions: (options: (IOption & any)[]) => IOption[] | GroupBase<IOption>[]
}

const renderUsers: React.FC<WrappedFieldArrayProps<any> & Props> = ({
  addLabel = 'add user',
  itemValidate = required,
  fields,
  meta,
  prepareOptions
}) => {
  const addField = () => fields.push({})

  const removeField = (idx: number) => () => fields.remove(idx)

  return (
    <>
      <Title>Available to these users:</Title>
      {fields.map((field, idx) => (
        <UserWrapper key={field}>
          <ReduxAsyncPaginatedSelect
            name={field}
            validate={itemValidate}
            menuPortalTarget={null}
            query={OWNED_BY_SELECT_QUERY}
            prepareOptions={prepareOptions}
            getOptions={userAndPositionProps.getOptions}
            filterKeys={[
              ['userFilter', 'name'],
              ['positionFilter', 'description']
            ]}
          />
          <CloseIcon data-testid='users-list-remove' data-entity-id={idx} onClick={removeField(idx)} />
        </UserWrapper>
      ))}

      <AddButton data-testid='users-list-add' onClick={addField}>
        + {addLabel}
      </AddButton>
      {meta.submitFailed && meta.error && <ErrorText data-testid='users-list-error'>{meta.error}</ErrorText>}
    </>
  )
}

export default renderUsers
